import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { SumExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/SumExpression";

export class SumExpressionEditor extends ExpressionRuleEditor<SumExpression> {
    render() {
        return (
            <ExpressionPiece>
                sum
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </BracketedDiv>
            </ExpressionPiece>
        );
    }
}
